/**
 * @module app.bdc.reports.eSignCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ESignCtrl($rootScope, $location, $window, orderService, commonService, reportRoutingService) {
        var self = {};
        self.order = $rootScope.order;
        self.url = '';
        self.signed = false;
        self.documents = [];
        self.loading = false;

        if(!self.order) $location.path('/bdc/list');

        self.getEsignUrl = () => {
            let id = self.order.contract.contractType.code === 'ACHAT' ? self.order.id : self.order.idElectronicSignature;
            return orderService.getEsignUrl(id).then(url => {
                console.log(url);
                self.url = url;
                if(!self.order.isSigned || self.order.contract.contractType.code === 'ACHAT') {
                    reportRoutingService.goToOrderForm();
                    $window.open(self.url, '_blank');
                }else {
                    self.getDocuments ();
                }
            }).catch(err => {
                console.log(err.data)
                if(err.data.message === '400 : Bad Request "Le client a déjà signé"'
                || err.data.message === '400 : Bad Request "Tous les signataires ont signés"') {
                    self.signed = true;
                    self.getDocuments ();
                }
            });
        };

        self.getDocuments = () => {
            self.loading = true;
            let id = self.order.contract.contractType.code === 'ACHAT' ? self.order.id : self.order.idElectronicSignature;
            orderService.getDocuments(id).then(docs => {
               console.log(docs)
               self.documents = docs;
            }).then(()=>{
                self.loading = false;
            }).catch (err => {
                console.log(err.data);
                self.loading = false;
            });

        }

        self.viewDocument = (data, type = 'application/pdf') => {
            let blob = null;
            blob = commonService.b64toBlob(data, type);
            const blobURL = URL.createObjectURL(blob);
            $window.open(blobURL);
            URL.revokeObjectURL(blobURL);
        };

        self.getEsignUrl();


        return self;
    }

    ESignCtrl.$inject = ['$rootScope', '$location', '$window', 'orderService', 'commonService', 'reportRoutingService'];

    angular
        .module('app.bdc.reports.eSignCtrl', [])
        .config(function($sceDelegateProvider) {
            $sceDelegateProvider.trustedResourceUrlList([
                // Allow same origin resource loads.
                'self',
                // Allow loading from our assets domain. **.
                'https://orisha.aplizdev.fr/**',
                'https://orisha.apliz.fr/**'
            ])
        })
        .controller('ESignCtrl', ESignCtrl);
});
